import { conditions, handleVideoType, videoTag } from "helpers";
import { ConditionName, IViewedVideo } from "interfaces";
import { createVideoSettings, handlePlayPause, handleVideoTimeline } from "redux-share/actions";
import { setShowContinuousePlayback, setVideoSettings } from "redux-share/slices/userSlice";
import store from "redux-share/store";

export const enum useContinuousePlaybackEnums {
    timer = "timer"
}

export interface IUseContinuousePlayback {
    type: useContinuousePlaybackEnums.timer;
}

export const handleContinuousPlayback = () => {
    const { videoSettings } = store.getState().user;
    const { params } = store.getState().videoData;
    const type: string = params.type!.toString();
    const isLogin = conditions(ConditionName.isLogin);
    const currentTime = videoTag().currentTime;
    if (type !== "live" && currentTime !== 0) {
        const duration = videoTag().duration;
        const viewedVideo: IViewedVideo = {
            video_id: +params.id!,
            video_type: handleVideoType(),
            time: currentTime === duration ? 0 : Math.floor(videoTag().currentTime),
            is_like: videoSettings.is_like
        };
        let viewedVideosInLocalStorage = localStorage.getItem("viewedVideos");
        if (viewedVideosInLocalStorage) {
            let viewedVideos: IViewedVideo[] = JSON.parse(viewedVideosInLocalStorage);
            viewedVideos = viewedVideos.filter(
                (video: IViewedVideo) => video.video_id !== viewedVideo.video_id || video.video_type !== viewedVideo.video_type
            );
            if (viewedVideos.length < 10) viewedVideos.push(viewedVideo);
            else {
                viewedVideos.shift();
                viewedVideos.push(viewedVideo);
            }
            localStorage.setItem("viewedVideos", JSON.stringify(viewedVideos));
        } else localStorage.setItem("viewedVideos", JSON.stringify([viewedVideo]));
        if (isLogin) createVideoSettings(viewedVideo);
    }
};

export const handleApplyContinuousPlayback = () => {
    const dispatch = store.dispatch;
    const { params } = store.getState().videoData;
    let viewedVideosInLocalStorage = localStorage.getItem("viewedVideos");
    if (viewedVideosInLocalStorage) {
        const viewedVideos: IViewedVideo[] = JSON.parse(viewedVideosInLocalStorage);
        const viewedVideo = viewedVideos.find(
            (video: IViewedVideo) => video.video_id === Number(params.id) && video.video_type === handleVideoType()
        );

        if (viewedVideo) {
            dispatch(setVideoSettings({ is_like: viewedVideo.is_like, time: viewedVideo.time }));
            if (viewedVideo.time !== 0) dispatch(setShowContinuousePlayback(true));
        }
    }
};

export const handleShowContinuousVideo = (event: any) => {
    const dispatch = store.dispatch;
    const { videoSettings } = store.getState().user;
    handlePlayPause(event);
    handleVideoTimeline(videoSettings.time);
    dispatch(setShowContinuousePlayback(false));
};

export const handleGoToFirstVideo = (event: any) => {
    const dispatch = store.dispatch;
    const { videoSettings } = store.getState().user;
    dispatch(setVideoSettings({ ...videoSettings, time: 0 }));
    dispatch(setShowContinuousePlayback(false));
    handlePlayPause(event);
};
